module.exports = __webpack_public_path__ + "assets/folder-shared.9239f533.svg";